<!-- 采购退货复核 -->
<template>
  <div>
    <purchaseReturnTemplate ref="purchaseReturnTemplate"></purchaseReturnTemplate>

    <div v-if="isLoaded">
      <div class="demo-drawer__content data_action_form">
        <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
          <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val)=>{showTabs=val}" @tabHeight="tabHeight">
            <template slot="tabs" slot-scope="scope">
              <div class="table_content_box">
                <!-- 主要信息 -->
                <div v-if="scope.index == 0&&scope.row.isShowForm!=1">
                  <el-form label-width="100px" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini">
                    <el-row v-if="dataActionBox.actionType !=2">
                      <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow==1" v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" :key="formOneKey" :prop="formOneValue.entityField"
                        :rules="formOneValue.isRequired == 1 && isReviewReq == true ? [{required:  formOneValue.isChange == 1, message:formOneValue.showField + '不能为空', trigger: ['blur', 'change']}] : []">
                        <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                        <!-- 结束日期 -->
                        <df-date class="form_codition" :isdisabled="formOneValue.isChange == 0" v-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                        <!-- 记账单号 -->
                        <el-tooltip v-else-if="formOneValue.fieldType == 'extract'" class="item"
                          :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9" effect="dark"
                          :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                          <el-input class="form_codition" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                            @keyup.enter.native="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField,formOneValue.nosetField)" :disabled="formOneValue.isChange==0 || dataActionBox.actionType == 1">
                            <el-button @click="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField,formOneValue.nosetField)" slot="append" icon="el-icon-search"
                              :disabled="formOneValue.isChange==0 || dataActionBox.actionType == 1"></el-button>
                          </el-input>
                        </el-tooltip>
                        <!-- <el-input v-else-if="formOneValue.entityField == 'rgamId'" :disabled="formOneValue.isChange == 0" v-model.trim="sendDataInfo[formOneValue.entityField]"
                        @focus="openExComponents(formOneValue.extractId, 0, 'rgamId')"></el-input> -->
                        <!-- 第二复核人 -->
                        <el-input class="form_codition" v-else-if="formOneValue.entityField == 'twoAuditName'" v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength" @focus="openReview"
                          :disabled="formOneValue.isChange == 0">
                        </el-input>
                        <el-input :disabled="formOneValue.isChange == 0" v-else v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                      </el-form-item>
                    </el-row>
                    <el-row v-if="dataActionBox.actionType ==2">
                      <el-form-item v-if="formOneValue.isShow==1" :label="formOneValue.showField+':'" v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                        <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)+':'"></label>

                        <span v-if="formOneValue.fieldType == 'date'">
                          <span v-if="sendDataInfo[formOneValue.entityField]">
                            {{$common.getLocalTime(sendDataInfo[formOneValue.entityField])}}
                          </span>
                        </span>
                        <span v-else-if="formOneValue.entityField == 'smId'">{{sendDataInfo.smName}}</span>
                        <span v-else-if="formOneValue.entityField == 'opmId'">{{sendDataInfo.opmName}}</span>
                        <span v-else-if="formOneValue.entityField == 'salesId'">{{sendDataInfo.salesName}}</span>
                        <span v-else-if="formOneValue.entityField == 'depId'">{{sendDataInfo.depName}}</span>
                        <span v-else-if="formOneValue.isRift == 1">
                          <a @click="toDetail(sendDataInfo[formOneValue.riftField])">
                            {{sendDataInfo[formOneValue.entityField]}}</a>
                        </span>
                        <span v-else>{{sendDataInfo[formOneValue.entityField]}}</span>
                      </el-form-item>
                    </el-row>
                  </el-form>
                  <!-- 明细 -->
                  <el-form :inline="true" size="mini">
                    <div id="operateBtn" v-if="dataActionBox.actionType !=2">
                      <el-button type="primary" size="mini" @click="toReview">复核</el-button>
                      <el-button type="primary" size="mini" @click="toggleSelection">取消选择</el-button>
                    </div>
                    <el-table :data="sendDataInfo.rgbkDetailVos" border style="width: 100%" :height="mxHeight" class="toReviewTable" ref="multipleTable" size="mini" :row-class-name="tableRowClassName" @row-click="on_select"
                      @selection-change="handleSelectionChange">
                      <el-table-column :selectable="checkboxT" type="selection" v-if="dataActionBox.actionType != 2" width="55">
                      </el-table-column>
                      <el-table-column align="center" v-for="(formOneValue,formOneKey) in mxForm" :key="formOneKey" :prop="formOneValue.entityField" :label="formOneValue.showField" show-overflow-tooltip :min-width="formOneValue.fieldWeight"
                        v-if="formOneValue.isShow==1">
                        <template slot-scope="scope">
                          <!-- 状态 -->
                          <el-tag size="mini" v-if="formOneValue.entityField == 'reviewStatus'">
                            {{scope.row.reviewStatus == 0? '未复核' : '已复核'}}
                          </el-tag>
                          <!-- 显示通用名称 -->
                          <span v-else-if="formOneValue.entityField == 'bgmId'">
                            {{sendDataInfo.rgbkDetailVos[scope.$index].bgmName}}
                          </span>
                          <!-- 有效期 -->
                          <span v-else-if="formOneValue.fieldType == 'date'">
                            <span v-if="sendDataInfo.rgbkDetailVos[scope.$index][formOneValue.entityField]">
                              {{$common.getLocalTime(sendDataInfo.rgbkDetailVos[scope.$index][formOneValue.entityField])}}
                            </span>
                          </span>
                          <span v-else-if="formOneValue.isRift == 1">
                            <a @click="toDetail(sendDataInfo.rgbkDetailVos[scope.$index][formOneValue.riftField])">
                              {{sendDataInfo.rgbkDetailVos[scope.$index][formOneValue.entityField]}}</a>
                          </span>
                          <!-- 生产日期 -->
                          <!-- 第二复合人 -->
                          <el-tag size="mini" v-else-if="formOneValue.entityField == 'isReview'">
                            {{scope.row.isReview == 1 ? '是' : '否'}}
                          </el-tag>
                          <span v-else>
                            {{sendDataInfo.rgbkDetailVos[scope.$index][formOneValue.entityField]}}
                          </span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-form>
                </div>

              </div>
            </template>
          </v-tabs>
        </el-card>
        <tree v-if="dataActionBox.actionType == 2" ref="tree" @tabHeight="(val)=>{mxHeight=val}"></tree>
        <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction" @showPrintPlan="showPrintPlan"></v-foot>
      </div>
    </div>
    <el-dialog top="1vh" :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth" :modal-append-to-body='true' :append-to-body="true">
      <ExtractionScheme ref="ExtractionScheme" :ppId="ppId" :id="exId" @TranData="getDataByChen" @getWidth="getWidth" @sendTitle="getExtractName" /><!-- 原：p-sReturnExtractionScheme :extractData="extractData1"  -->
    </el-dialog>
    <!-- 验证第二复核人 -->
    <el-dialog title="复核人验证" :visible.sync="reviewDialogFormVisible" :before-close="cancelReview" :modal-append-to-body='true' :append-to-body="true">
      <el-form ref="review">
        <el-form-item label="账号" :label-width="formLabelWidth">
          <el-input v-model="review.twoAudit"></el-input>
        </el-form-item>
        <el-form-item label="密码" :label-width="formLabelWidth" prop="pwd">
          <el-input type="password" v-model="review.pwd" show-password autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelReview">取 消</el-button>
        <el-button type="primary" @click="Authentication()">确 定</el-button>
      </div>
    </el-dialog>
    <printPlan ref="printPlan"></printPlan>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import ExtractionScheme from "../byComponents/ExtractionScheme.vue";
import purchaseReturnTemplate from "@/components/purchaseReturnTemplate.vue";
export default {
  name: "purchaseReturnReviewAction",
  props: ["actionData"],
  //import引入的组件需要注入到对象中才能使用
  components: {
    ExtractionScheme,
    purchaseReturnTemplate
  },
  data() {
    //这里存放数据
    return {
      dialogFormVisible: false,
      dataActionBox: {
        showStatus: false,
        openMode: "ltr" || "rtl",
        boxTitle: "新增" || "编辑",
        actionType: 0, // 0新增，1修改
      },
      sendDataInfo: {
        coId: 0,
        coName: "",
        credit: "",
        payMethod: "",
        psaiCarricus: "",
        psaiCarrier: "",
        psaiDeptime: 0,
        psaiExptime: 0,
        psaiId: 0,
        psaiReserves1: "",
        psaiReserves2: "",
        psaiReserves3: "",
        psaiReserves4: "",
        psaiReserves5: "",
        psaiReserves6: "",
        settleMethod: "",
        psaiId: "",
        psbkmId: "",
        rgamCsalesman: "",
        rgamId: "",
        rgamName: "",
        rgamPurchaser: "",
        rgamRapcus: "",
        rgamRapdate: "",
        rgamRemark: "",
        rgamReserves1: "",
        rgamReserves2: "",
        rgamReserves3: "",
        rgamReserves4: "",
        rgamReserves5: "",
        rgamReserves6: "",
        rgamSapdept: 0,
        totalCount: 0,
        totalMoney: 0,
        totalNumber: 0,
        rgbkDetailVos: [],
        depId: 0,
        depName: "",
        opmId: 0,
        opmName: "",
        rgbmId: "",
        salesId: "",
        salesName: "",
        smId: 0,
        smName: "",
        twoAudit: 0,
        twoAuditName: "",
        tabForm: [],
        mxForm: [],
        footForm: [],
      },
      review: {
        twoAudit: "",
        pwd: "",
      },
      reviewRules: {
        twoAudit: [
          { required: true, message: "请填写复核人", trigger: "blur" },
        ],
        pwd: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      actionDataInfo: {
        rgmId: 0,
        rgreviewerDetailVos: [],
      },
      showTabs: "",
      formDataList: [],
      userOneList: [],
      reviewUserInfo: {
        opmId: "",
        passWord: "",
        selectIndex: 0,
        actionNumber: 0,
        isReviewUser: true,
      },
      actionIndex: "",
      ishowRew: true,
      exId: "",
      seId: "",
      ceshi: "",
      dialogTitle: "",
      seWidth: "",
      height: "",
      exTitle: "",
      seTitle: "",
      seWidth: "",
      exWidth: "",
      DialogVisible: false,
      DialogExtract: false,
      newFormDataList: [],
      seType: "",
      smId: "",
      ppId: "",
      multipleSelection: [],
      isReviewReq: false,
      reviewDialogFormVisible: false,
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      formLabelWidth: "120px",
      isLoaded: false,
      mxHeight: 0,
      tabForm: [],
      mxForm: [],
      footForm: [],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    "sendDataInfo.rgbkDetailVos": {
      handler: function (newValue, oldValue) {
        this.sendDataInfo.rgbkDetailVos = newValue;
        console.log(newValue);
      },
      deep: true,
    },
  },
  //方法集合
  methods: {
    tabHeight(val) {
      this.mxHeight = val
    },
    showPrintPlan() {
      // 打印方法
      // 调用全局方法 判断Websocket是否连接
      if (this.$printSocketApi.printExeMsg() != false) {
        // 选中的数据
        this.$refs.printPlan.openDia(
          this.actionData.orderId,
          this.actionData.printSouce,
          this.actionData.printJurId
        );
      } else {
        return;
      }
    },
    // 获取主表单所有input
    getMainInput() {
      var el = document.getElementById("mainInfo");
      if (el) this.inputel = el.getElementsByTagName("input");
    },
    changeFocus() {
      setTimeout(() => {
        var el = document.getElementById("mainInfo");
        var inel = el.getElementsByClassName("el-input__inner");
        for (let index = 0; index < inel.length; index++) {
          if (inel[index].value == "") {
            console.log(inel[index]);
            inel[index].focus();
            break;
          }
        }
      }, 500);
    },
    toDetail(orderId) {
      this.$parent.$parent.$parent.toDetail(orderId);
    },
    Authentication() {
      this.reviewSub();
    },
    async reviewSub() {
      var opmId;
      this.userOneList.forEach((item) => {
        if (item.opmName == this.review.twoAudit) {
          opmId = item.opmId;
        }
      });
      let data = {
        opmAccount: this.review.twoAudit,
        passWord: this.review.pwd,
      };
      let responseData = await this.$http.reviewVerification(data);
      if (responseData.status == 200) {
        this.review.twoAudit = responseData.result.opmName
        this.sendDataInfo.twoAudit = responseData.result.opmId;
        this.sendDataInfo.twoAuditName = responseData.result.opmName
        this.$message({
          type: "success",
          message: "验证成功",
        });
        this.reviewDialogFormVisible = false;
      } else {
        this.$message({
          type: "error",
          message: responseData.message,
        });
      }
    },
    cancelReview() {
      this.reviewDialogFormVisible = false;
    },
    openReview() {
      // this.dialogFormVisible = true
      this.review.twoAudit = "";
      this.review.pwd = "";
      this.reviewDialogFormVisible = true;
    },
    //复选框
    checkboxT(row, rowIndex) {
      // this.sendDataInfo.rgbkDetailVos[rowIndex].reviewStatus == 1
      if (this.sendDataInfo.rgbkDetailVos[rowIndex].reviewStatus == 1) {
        //      if(row.lie =='1'){
        return false; //禁用
      } else {
        return true; //不禁用
      }
    },
    // 添加索引
    tableRowClassName(row, index) {
      // 给每条数据添加一个索引
      row.row.index = row.rowIndex;
    },
    toReview() {
      if (this.sendDataInfo.rgbkDetailVos.length == 0) {
        return this.$message({
          type: "warning",
          message: "暂无复核明细",
        });
      } else if (this.multipleSelection.length == 0) {
        return this.$message({
          type: "warning",
          message: "请先选中明细",
        });
      }
      this.$confirm("确定复核选中订单吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //拿到选中的数据
          let val = this.multipleSelection;
          //如果选中数据存在
          if (val) {
            //将选中数据遍历
            val.forEach((val, index) => {
              //遍历源数据
              this.sendDataInfo.rgbkDetailVos.forEach((v, i) => {
                //如果选中数据和源数据的某一条唯一标识符相等，删除对应的源数据
                if (val.index === v.index) {
                  this.sendDataInfo.rgbkDetailVos[index].reviewStatus = 1;
                  // console.log(this.sendDataInfo.rgbkDetailVos[i])
                }
              });
            });
          }
          this.sendDataInfo.rgbkDetailVos.splice(1, 0);
          this.$message({
            type: "success",
            message: "已复核",
          });
        })
        .catch(() => { });
    },
    on_select(val) {
      //点击行选中复选框
      this.$refs.multipleTable.toggleRowSelection(val);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(val);
    },
    toggleSelection() {
      if (this.multipleSelection.length == 0) {
        return this.$message({
          type: "warning",
          message: "暂无选择明细",
        });
      }
      this.$refs.multipleTable.clearSelection();
    },
    async getDataByChen(val) {
      if (val != "" || val != undefined) {
        for (let key in val) {
          if (key == "arrlistbychen") {
            this.sendDataInfo.rgbkDetailVos = val.arrlistbychen;
          } else {
            this.sendDataInfo[key] = val[key];
            this.sendDataInfo.rgavRapdate = val.rgamRapdate;
          }
        }
        this.sendDataInfo.rgbkDetailVos.forEach((item) => {
          item.rgreOldnumber = item.rgdOldnumber;
          item.rgreRetnumber = item.rgdRetnumber;
          item.reviewStatus = 0;

          if (item.isReview == 1) {
            this.isReviewReq = true;
          }
        });
        this.DialogExtract = false;
      }
    },
    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    getWidth(e) {
      this.exWidth = e + "%";
    },
    getSearchName(e) {
      this.seTitle = e;
    },
    getExtractName(e) {
      this.exTitle = e;
    },
    // 提取方案Id, 索引(表格中), 标识
    openExComponents(eId, index, type) {
      this.DialogExtract = true;
      this.exId = eId;
      this.seIndex = index;
      this.seType = type;
      this.ppId = "rgamId";
      this.extractData1 = {
        id: this.exId,
        ppId: this.ppId,
        idType: "ormId",
      };
    },
    // 提取采购退货草稿
    async extractData(data) {
      if (data) {
        var sendData = [data.rgamId];
        let responseData = await this.$http.extractPurchaseReturnOrder({
          ids: sendData,
        });
        if (responseData.status == 200) {
          var info = responseData.result;
          info.rgbkDetailVos.forEach((item, keys) => {
            info.rgbkDetailVos[keys].reviewStatus = 0;
          });
          this.sendDataInfo = info;
          console.log(this.sendDataInfo);
        } else {
          this.$message({
            message: responseData.message,
            type: "error",
          });
        }
      }
    },
    async sendDataAction(sendDataInfo) {
      this.$refs.sendDataInfo.validate((valid) => {
        if (valid) {
          if (this.sendDataInfo.rgbkDetailVos.length == 0) {
            return this.$message({
              message: "请完善信息",
              type: "error",
            });
          }
          var isNext = true;
          this.sendDataInfo.rgbkDetailVos.forEach((item) => {
            if (item.reviewStatus == 0) {
              isNext = false;
              return false;
            }
          });
          if (isNext == false) {
            this.$message({
              message: "明细必须全部复核",
              type: "error",
            });
            return false;
          }
          this.sub();
        }
      });
    },
    async sub() {
      let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
      var responseData = await this.$http.addPurchaseReturnReviewer(sendData);
      if (responseData.status == 200) {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.$emit("drawerCancel");
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },

    // 获取复核人
    async getSpecialUser() {
      let responseData = await this.$http.getSpecialUser({ opmReviewer: 1 });
      if (responseData.status == 200) {
        this.userOneList = responseData.result;
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },

    // 复核验证
    async reviewVerification() {
      var sendInfo = {
        opmId: this.userOneList[this.reviewUserInfo.selectIndex].opmId,
        passWord: this.reviewUserInfo.passWord,
      };
      let responseData = await this.$http.reviewVerification(sendInfo);
      if (responseData.status == 200) {
      } else {
      }
    },

    initActionBox(sendDataInfo) {
      this.$confirm("确定取消新增吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$common.delOrderInfo(this.sendDataInfo.rgamId)
          this.dataActionBox.actionType = 0;
          this.$emit("drawerCancel");
          this.init();
          this.$refs[sendDataInfo].resetFields();
        })
        .catch(() => {
          // this.$message({
          //     type: 'info',
          //     message: '取消关闭'
          // });
        });
    },
    init() {
      for (let key in this.sendDataInfo) {
        if (key == "rgbkDetailVos") {
          this.sendDataInfo[key] = {};
          for (let sonOne in this.sendDataInfo[key]) {
            this.sendDataInfo[key][sonOne] = "";
          }
        } else {
          this.sendDataInfo[key] = "";
        }
      }

      this.sendDataInfo.totalCount = 0;
      this.sendDataInfo.totalMoney = 0;
      this.sendDataInfo.totalNumber = 0;
      this.sendDataInfo.rgbkDetailVos = [];
    },

    reviewAction(index) {
      this.dialogFormVisible = true;
      var data = this.sendDataInfo.rgbkDetailVos[index];
      this.reviewUserInfo.isReviewUser = true;
      this.reviewUserInfo.actionNumber = 0;
      if (data.isReview == 1) {
        this.actionIndex = index;
        this.reviewUserInfo.opmId = "";
        this.reviewUserInfo.passWord = "";
        this.reviewUserInfo.selectIndex = 0;
        this.reviewUserInfo.actionNumber = 0;
      } else {
        this.reviewUserInfo.isReviewUser = false;
      }
    },

    // 新增复核数据
    insertReviewData(index) {
      this.ishowRew = false;
      var data = this.sendDataInfo.rgbkDetailVos[index];

      this.sendDataInfo.rgbkDetailVos[index].reviewStatus = 1;
      this.sendDataInfo.rgbkDetailVos[index].rgdRenumber =
        this.reviewUserInfo.actionNumber;
      this.sendDataInfo.rgbkDetailVos[index].rgdSechecker =
        this.userOneList[this.reviewUserInfo.selectIndex].opmId;
      this.sendDataInfo.rgbkDetailVos[index].rgdSecheckerName =
        this.userOneList[this.reviewUserInfo.selectIndex].opmName;

      this.dialogFormVisible = false;
      this.ishowRew = true;
    },

    openBox() {
      this.dataActionBox.actionType = this.actionData.cate;
      this.formDataList = this.actionData.formData;
      this.filterMainField();
      var oldData = this.actionData.oldData;
      this.showTabs = this.actionData.formData[0].jciName;
      if (this.dataActionBox.actionType == 0) {
        this.isReviewReq = false;
        this.mxForm.forEach((item, i) => {
          if (item.entityField == "reviewStatus") {
            this.mxForm.splice(i, 1);
          }
        });
        var newObj = {
          chineseField: "状态",
          entityField: "reviewStatus",
          fieldType: "string",
          isChange: 0,
          isRequired: 1,
          isReserved: 0,
          isShow: 1,
          showField: "状态",
          sort: 1,
        };
        this.mxForm.unshift(newObj);
        this.init();
        this.dataActionBox.boxTitle = "创建复刻单";
        this.dataActionBox.openMode = "ltr";
        // this.sendDataInfo.rgreRapdate = this.$moment().valueOf();
      } else {
        this.dataActionBox.boxTitle = "查看信息";
        var dataInfo = JSON.parse(JSON.stringify(oldData));
        for (let key in dataInfo) {
          this.$set(this.sendDataInfo, key, dataInfo[key])
        }
      }
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.dataActionBox.actionType != 2) {
            this.mxHeight = this.$common.getBtnHeight()
          } else {
            this.$refs['tree'].init(this.sendDataInfo.rgavId)
            this.mxHeight = this.$common.getHeight()
          }
        }, 100)
      });
      this.changeFocus();
    },
    // 过滤表单不同类型
    filterMainField() {
      var mainFormList = [];
      this.formDataList.forEach((item) => {
        if (item.jciType == 1) {
          mainFormList.push(item);
        } else if (item.jciType == 2) {
          this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform));
        } else if (item.jciType == 3) {
          this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
        }
      });
      mainFormList.forEach((key, i) => {
        this.tabForm[i] = JSON.parse(JSON.stringify(key));
        this.tabForm[i].jurconfigform = [];
        for (let index = 0; index < key.jurconfigform.length; index++) {
          if (key.jurconfigform[index].isShow == 1)
            this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
        }
      });
      var arr = [{ entityField: "rgbkDetailVos" }]
      var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
      for (let key in obj) {
        this.$set(this.sendDataInfo, key, obj[key])
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.$nextTick(() => {
      this.openBox();
      this.isLoaded = true;
    });
    this.getSpecialUser();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() {
    this.getMainInput();
  }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
  height: 200px;
  background-color: red;
}
.table_content_box {
  /* height: 500px !important; */
  overflow-y: auto;
}
.el-row {
  display: flex;
  flex-wrap: wrap;
  padding-right: 20px;
}
.mb {
  margin-bottom: 0;
}
::v-deep .toReviewTable tr td:first-child .cell,
::v-deep .toReviewTable tr th:first-child .cell {
  text-align: center;
}
::v-deep .toReviewTable .el-checkbox__inner {
  width: 18px;
  height: 18px;
}
::v-deep .toReviewTable .el-checkbox__inner::after {
  height: 8px;
  left: 6px;
  top: 2px;
  width: 5px;
}
::v-deep
  .toReviewTable
  .el-checkbox__input.is-indeterminate
  .el-checkbox__inner::before {
  height: 2px;
  left: 0;
  right: 0;
  top: 7px;
}
</style>